module.exports = __webpack_public_path__ + "img/img-green_bg.e03c4e55.svg";